import {
  PREGNANT_AND_NEWBORN_ABOUT_CHILD_STEP,
  PREGNANT_AND_NEWBORN_ABOUT_YOU_STEP,
} from "Components/Features/CheckPrice/Products/LifeProducts/PregnantAndNewborn";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { PregnantAndNewbornCoverage } from "Store/interfaces/products/coverage";
import { nullableFormBooleanToNullableBoolean } from "Utils/formUtils";
import { format } from "date-fns";

export type PregnantAndNewbornProductBackend = {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: any;
  childBirthDate: string;
  customerDateOfBirth: string;
  pregnant: boolean;
  multipleChildren: boolean;
  isScandinavianCitizen?: boolean | null;
  isStayingInNorwayForMoreThanFiveYears?: boolean | null;
};

export function mapToCommercePregnantAndNewborn(data: {
  [key: string]: any;
}): PregnantAndNewbornProductBackend {
  const formValues = data.formData;
  const pregnant = !nullableFormBooleanToNullableBoolean(
    formValues[PREGNANT_AND_NEWBORN_ABOUT_CHILD_STEP.id].childBorn,
  );
  const multipleChildren = !!nullableFormBooleanToNullableBoolean(
    formValues[PREGNANT_AND_NEWBORN_ABOUT_CHILD_STEP.id].multipleChildren,
  );
  const childBirthDate = format(
    formValues[PREGNANT_AND_NEWBORN_ABOUT_CHILD_STEP.id].birthDate,
    "yyyy-MM-dd",
  );
  const isScandinavianCitizen = nullableFormBooleanToNullableBoolean(
    formValues[PREGNANT_AND_NEWBORN_ABOUT_YOU_STEP.id].isScandinavianCitizen,
  );
  const isStayingInNorwayForMoreThanFiveYears =
    isScandinavianCitizen === true
      ? null
      : nullableFormBooleanToNullableBoolean(
          formValues[PREGNANT_AND_NEWBORN_ABOUT_YOU_STEP.id]
            .isStayingInNorwayForMoreThanFiveYears,
        );
  const customerDateOfBirth = data.customerData.newCustomerResponse.dateOfBirth;

  return {
    name: INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN,
    coverageGroup: coverageFrom(pregnant, multipleChildren),
    pregnant,
    multipleChildren,
    childBirthDate,
    customerDateOfBirth,
    isScandinavianCitizen,
    isStayingInNorwayForMoreThanFiveYears,
  };
}

export const coverageFrom = (
  pregnant: boolean,
  multipleChildren: boolean,
): PregnantAndNewbornCoverage => {
  if (pregnant) {
    if (multipleChildren) {
      return PregnantAndNewbornCoverage.PREGNANT_MULTIPLE_CHILDREN;
    }
    return PregnantAndNewbornCoverage.PREGNANT;
  }
  if (multipleChildren) {
    return PregnantAndNewbornCoverage.NEWBORN_MULTIPLE_CHILDREN;
  }
  return PregnantAndNewbornCoverage.NEWBORN;
};
